import { Component } from '@angular/core';
import { ViewController,NavParams  } from 'ionic-angular';
import { FormBuilder, Validators } from '@angular/forms';
import { LoaddingService } from './../../providers/loadding.service';
import { StorageService } from './../../providers/storage.service';
import { AlertService } from './../../providers/alert.service';
import { UserVarifyService } from '../../services/userVarify.service';
import { UserModel } from './../../models/user.model';

import { AppConfig } from '../../app/app.config';

@Component({
  selector: 'page-revise-money',
  templateUrl: 'reviseMoney.html',
  providers: [
    AlertService,
    UserVarifyService
  ]
})
export class ReviseMoneyPage {
    AppConfig = AppConfig;
  user:UserModel;
  
  constructor(
    public navParams: NavParams,
    private ViewCtrl: ViewController,
    private alert: AlertService,
    private loadding: LoaddingService,
    private storage: StorageService,
    private userService: UserVarifyService,
    private formBuilder: FormBuilder
) {}

  setMoneyForm = this.formBuilder.group({
    'old': ['', [Validators.required]],
    'newOne': ['', [Validators.required]],
    'newTwo': ['', [Validators.required]]
  });

  ionViewDidLoad() {
      this.user=this.storage.read<UserModel>("User");
  }


    //修改资金密码
    //chen 2017-06-07
    reviseLogin(obj){
        if(obj.newOne==obj.newTwo){
           this.userService.updateBankPwd({UserName:this.user.UserName,OldPwd:obj.old,NewPwd:obj.newOne}).then(s => {
               this.alert.showAlert(s.Error);
               this.ViewCtrl.dismiss();
           });
        }else{
            this.alert.showAlert("新密码前后不一致，请重新输入");
        }
    }

  	//页面关闭
    //chen 2017-03-13
	dismiss() {
		this.ViewCtrl.dismiss();
	}

}



// WEBPACK FOOTER //
// ./src/pages/password/reviseMoney.ts